<app-tabla
  [datos]="eventosHistorico"
  [columnas]="columnas"
  [totalCount]="totalCount"
  [(query)]="query"
  (queryChange)="listar()"
  [filtros]="filtros"
  [firstLastButtons]="false"
  [goto]="false"
  [emptyState]="{
    title: 'Todavía no hay eventos finalizados',
    subtitle: 'Los eventos que se finalicen van a aparecer acá.',
  }"
></app-tabla>
